<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-16 14:20:14
 * @LastEditTime: 2022-03-31 16:09:30
-->
<template>
  <div class="addParams">
    <div class="radio-select">
      <el-button
        size="mini"
        type="primary"
        @click="radioChange('新建采集模板')"
        >{{ $t("lang.FastAccess.NewTemplate") }}</el-button
      >
    </div>
    <div class="params">
      <div class="template">
        <el-radio-group ref="groupRadio" v-model="selectTemplate">
          <el-radio
            v-for="item in templateList"
            :key="item.id"
            :label="item"
            :class="setTemplate(item)"
            >{{ item.name }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="paramsTable">
        <add-params
          :templateType="selectTemplate.type"
          :templateId="selectTemplate.id"
          @setParamsIds="setParamsIds"
          height="400"
        >
          <span slot="slot">
            <el-button
              style="margin-left: 20px"
              size="mini"
              type="success"
              @click="paramsMonitor"
              >{{ $t("lang.FastAccess.IssueCollection") }}</el-button
            >
          </span>
        </add-params>
      </div>
    </div>
    <div style="text-align: center; margin-top: 50px">
      <el-button size="mini" @click="preStep">{{
        $t("lang.FastAccess.previous")
      }}</el-button>
      <el-button size="mini" type="primary" @click="next">{{
        $t("lang.FastAccess.ConfirmAdd")
      }}</el-button>
    </div>
    <!-- 新建采集模板 -->
    <el-dialog
      :title="$t('lang.devicesManagement.addATemplate')"
      center
      width="40%"
      :visible.sync="dialogVisible"
      @close="hide"
    >
      <div class="collect-form">
        <el-form
          :model="collectForm"
          ref="collectForm"
          :rules="rules"
          label-width="100px"
          label-position="right"
        >
          <el-form-item
            :label="$t('lang.terminalList.Templatecategory')"
            prop="type"
          >
            <el-select v-model="collectForm.type" size="mini" disabled>
              <el-option value="0" label="modbus"></el-option>
              <el-option value="1" label="IO Control"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('lang.terminalList.templateName')"
            prop="name"
          >
            <el-input
              class="form-input"
              size="mini"
              v-model="collectForm.name"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="hide">{{
          $t("lang.terminalList.Cancel")
        }}</el-button>
        <el-button size="mini" type="primary" @click="submitForm">{{
          $t("lang.terminalList.Confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import addParams from "../../components/addParams";
import {
  getTemplate,
  deleteTemplate,
  addTemplate,
} from "@/api/cloudMonitor/templateList";
import { monitorParams, getParams } from "@/api/cloudMonitor/paramsList";
import { monitor } from "@/api/cloudMonitor/terminalList";
import { terminalForm } from "@/mixins/terminalForm";
import {
  addTerminal,
  editTerminal,
  monitorTerminal,
} from "@/api/cloudMonitor/terminalList";
import { listConfig, updateConfig } from "@/api/configurationlist";
export default {
  props: ["terminalInfo", "deviceInfo", "type"],
  mixins: [terminalForm],
  components: {
    addParams,
  },

  data() {
    return {
      editFlag: {
        comFlag: false, //串口配置修改是否成功
        monitorFlag: false, //下发指令是否成功
      },
      dialogVisible: false,
      radioValue: this.$t("lang.FastAccess.collectionTemplate"),
      templateList: [],
      metaList: [],
      selectTemplate: {},
      paramsIds: [], // 缓存更改的变量id
      defaultProps: {
        children: "children",
        label: "name",
      },
      isAdd: false, // 是否新建模板，新建后直接显示新建后采集模板的变量列表
      collectForm: {
        name: "",
        admodel: 1,
        type: "0",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("lang.FastAccess.pleaseTname"),
            trigger: ["blur"],
          },
        ],
        admodel: [
          {
            required: true,
            message: this.$t("lang.FastAccess.selectedCollection"),
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    editFlag: {
      immediate: true,
      deep: true,
      handler() {
        if (
          this.editFlag.comFlag === true &&
          this.editFlag.monitorFlag === true
        ) {
          this.$emit("next");
        }
      },
    },
    deviceInfo: {
      immediate: true,
      deep: true,
      handler() {
        if (this.deviceInfo.deviceId) {
          this.terminalInfo.device = this.deviceInfo;
        }
      },
    },
    type(newVal, oldVal) {
      this.collectForm.type = newVal;
      this.templateList = this.metaList.filter((v) => v.type == this.type);
    },
  },
  mounted() {
    this.getList();
    if (this.templateList.length == 0) {
      this.radioValue = this.$t("lang.FastAccess.NewTemplate");
    }
  },
  methods: {
    // 获取现有采集模板列表
    getList() {
      let params = {
        current: 1,
        size: 99999,
      };
      getTemplate(params)
        .then((res) => {
          let data = res.data.data;
          if (res.data.code === 0) {
            // this.templateList = data.records
            this.metaList = data.records;
            this.templateList = this.metaList.filter(
              (v) => v.type == this.type
            );
            if (!this.isAdd) {
              // 初始值为第一个，新建后自动定位到新建后的数据上
              this.selectTemplate = this.templateList[0] || { id: "" };
            }
          }
        })
        .catch(() => {});
    },
    // 设置缓存的变量Id
    setParamsIds(val) {
      this.paramsIds.push(val);
      this.paramsIds = Array.from(new Set(this.paramsIds));
    },
    // 添加采集配置模板
    submitForm() {
      this.$refs["collectForm"].validate((valid) => {
        if (valid) {
          addTemplate(this.collectForm)
            .then((res) => {
              if (res.data.code === 0) {
                this.selectTemplate = {};
                this.selectTemplate = this.collectForm;
                this.$set(this.selectTemplate, "id", res.data.data);
                this.isAdd = true;
                this.getList();
                this.$message.success(this.$t("lang.alarmNotice.msg8"));
                this.dialogVisible = false;
                this.radioValue = this.$t("lang.FastAccess.collectionTemplate");
              } else {
                this.$message.error(this.$t("lang.alarmNotice.msg8"));
              }
            })
            .catch(() => {});
        }
      });
    },
    // hide点击取消按钮
    hide() {
      this.dialogVisible = false;
      this.radioValue = this.$t("lang.FastAccess.collectionTemplate");
    },
    // 新建、选择按钮
    radioChange(val) {
      if (val === "新建采集模板") {
        this.dialogVisible = true;
        this.collectForm = {
          name: "",
          admodel: 1,
          type: this.type ? this.type : "0",
        };
      } else {
        this.dialogVisible = false;
      }
    },
    // 初始化editFlag
    clearData() {
      this.editFlag = {
        comFlag: false, //串口配置修改是否成功
        monitorFlag: false, //下发指令是否成功
      };
    },
    // 下发变量采集
    paramsMonitor() {
      if (this.paramsIds.length > 0) {
        let monitorData = {
          mid: this.selectTemplate.id,
          vids: this.paramsIds,
          type: this.type,
        };
        // 针对变量的变动
        monitorParams(monitorData)
          .then((res) => {
            if (res.data.code === 0) {
              this.paramsIds = [];
              this.$message.success(
                this.$t("lang.FastAccess.Commandissuedsuccessfully")
              );
            } else {
              this.$message.error(this.$t("lang.collect.msg6"));
            }
          })
          .catch(() => {
            this.$message.error(this.$t("lang.alarmList.msg3"));
          });
      }
    },
    next() {
      // 下一步的时候对终端模板信息进行采集
      if (this.paramsIds.length > 0) {
        this.$message.warning(this.$t("lang.FastAccess.warning1"));
      } else {
        // 对终端进行处理
        getParams(this.selectTemplate.id, this.selectTemplate.type)
          .then((res) => {
            if (res.data.data.length > 0) {
              this.handleTerminal();
            } else {
              this.$message({
                type: "warning",
                message: this.$t("lang.FastAccess.variablesfirst"),
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "warning",
              message: this.$t("lang.FastAccess.variablelist"),
            });
          });
      }
    },
    // 对终端进行添加、串口配置操作
    handleTerminal() {
      this.terminalInfo.did = this.deviceInfo.deviceDid;
      this.terminalInfo.template = this.selectTemplate;
      let submitData = this.setSubmitData(this.terminalInfo);
      this.$set(submitData, "dsn", this.deviceInfo.deviceSn);
      console.log(submitData);
      if (this.terminalInfo.id) {
        // 从启动采集返回上一步时
        this.$set(submitData, "proType", this.originalPotocol);
        editTerminal(submitData)
          .then((res) => {
            if (res.data.code === 0) {
              this.originalPotocol = submitData.protocol;
              // 成功后要同时修改串口配置
              if (this.terminalInfo.protocol == 2) {
                this.updateCom();
              } else {
                this.editFlag.comFlag = true;
              }
              // 针对终端绑定模板，同时要采集指令
              this.updateMonitor(res.data.data, submitData.type);
              this.iotConfig(0, res.data.data);
              this.$emit("updateList");
            } else {
              this.$message.error(this.$t("lang.alarmNotice.msg7"));
            }
          })
          .catch(() => {});
      } else {
        // 新建终端
        addTerminal(submitData)
          .then((res) => {
            if (res.data.code === 0) {
              this.terminalInfo.id = res.data.data;
              this.originalPotocol = submitData.protocol;
              // 成功后要同时修改串口配置
              if (this.terminalInfo.protocol == 2) {
                this.updateCom();
              } else {
                this.editFlag.comFlag = true;
              }
              // 针对终端绑定模板，同时要采集指令
              this.updateMonitor(res.data.data, submitData.type);
              this.iotConfig(1, res.data.data);
              this.$emit("updateList");
            } else {
              this.$message.error(this.$t("lang.editVar.msg20"));
            }
          })
          .catch((err) => {});
      }
    },
    preStep() {
      this.$emit("preStep");
    },
    // 修改串口配置
    updateCom() {
      if (this.terminalInfo.protocol == 2) {
        let arr = [
          {
            section: "serial",
            config: "smartlink",
            action: 0,
            index: [this.comIndex],
            options: {
              parity: this.terminalInfo.checkBit,
              data_bits: this.terminalInfo.dataBit,
              stop_bits: this.terminalInfo.stopBit,
              flow_ctrl: this.terminalInfo.xon,
              baudrate: this.terminalInfo.bps,
            },
          },
        ];
        updateConfig(
          this.terminalInfo.device.deviceSn,
          this.terminalInfo.device.deviceDid,
          arr
        )
          .then((res) => {
            if (res.data.code === 0) {
              this.editFlag.comFlag = true;
            } else {
              this.editFlag.comFlag = false;
              this.$message.error(
                this.$t("lang.FastAccess.configurationfailed")
              );
            }
          })
          .catch(() => {
            this.editFlag.comFlag = false;
            this.$message.error(this.$t("lang.FastAccess.configurationfailed"));
          });
      }
    },
    iotConfig(action, id) {
      monitorTerminal({
        action,
        dtuId: id,
      }).then((res) => {
        console.log(res);
      });
    },
    // 下发采集变量指令
    updateMonitor(id, type) {
      let data = {
        dtuId: id,
        type,
      };
      monitor(data)
        .then((res) => {
          if (res.data.code === 0) {
            this.editFlag.monitorFlag = true;
          } else {
            this.editFlag.monitorFlag = false;
            this.$message.success(this.$t("lang.FastAccess.terminalcommands"));
          }
        })
        .catch((err) => {
          this.editFlag.monitorFlag = false;
          this.$message.error(this.$t("lang.FastAccess.terminalcommands"));
        });
    },
    // 添加后聚焦到新添加的模板上
    setTemplate(item) {
      if (this.selectTemplate.id == item.id) {
        this.selectTemplate = item;
        return "isCheck";
      } else {
        return "";
      }
    },
    // 获取模板信息
    getTemplateInfo() {
      return this.selectTemplate;
    },
  },
};
</script>
<style scoped>
.paramsTable {
  overflow-y: scroll;
  width: 80%;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 10px;
}
.radio-select {
  margin-top: 50px;
}
.params {
  display: flex;
  margin-top: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  height: 500px;
}
.template {
  width: 20%;
  height: 100%;
  overflow: scroll;
  border-right: 1px solid #e4e7ed;
}
.el-radio-group {
  margin-top: 20px;
  width: 100%;
  overflow: hidden;
}
.el-radio {
  display: block;
  margin-bottom: 2px;
  height: 40px;
  width: 100%;
  line-height: 40px;
  margin-right: 0px;
  padding-left: 10px;
}
.isCheck {
  background-color: #cee0f1;
}
.el-radio:hover {
  background-color: #cee0f1;
}
.collect-form {
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
